import React from 'react';
import { WpPage_Flexiblecontent_FlexibleContent_BrandBar } from 'src/_generated/types';
import Image from '../elements/Image';
import { Section } from '../elements/Section';

export default function BrandBar({ brands, section }: WpPage_Flexiblecontent_FlexibleContent_BrandBar) {
  if (!brands?.logos) return null;

  return (
    <Section {...section}>
      <div className='bg-white px-4 md:px-[55px] relative flex justify-center'>
        <div className="items-center grid grid-cols-3 md:grid-cols-6 gap-[35px] md:gap-[50px] lg:gap-[92px] w-full  max-w-[994px]">
          {brands.logos.map((logo, i) => (
            <Image image={logo} key={`logo${i}`} className="w-full max-w-[60px] md:max-w-[91px] mx-auto brands-logo" />
          ))}
        </div>
      </div>
    </Section>
  );
}
